/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as moment from 'moment';

export const navigateToRequest = '/outstandingBalanaceByLabererAndQuarter';
export const viewClaimDetailButton = 'View Claim Detail';
